import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentView from 'material-ui/svg-icons/image/remove-red-eye';

const styles = {
    row: {height: '38px',},
    column: {height: '38px', paddingLeft: '20px', paddingRight: '20px'},
    columnFirst: {paddingLeft: '36px'},
    icon: {height: '32px', padding: '4px', overflow: 'inherit'}
};

const LocationAuditStaticTableRow = ({data, locationAuditPath, showView = false}) => (
    <TableRow style={styles.row}>
        <TableRowColumn colSpan={2} style={{...styles.column, ...styles.columnFirst}}>
            {data.audit_uuid}
        </TableRowColumn>
        <TableRowColumn style={styles.column}>
            {data.date}
        </TableRowColumn>
        <TableRowColumn style={styles.column}>
            {data.type}
        </TableRowColumn>

        {showView &&
        <TableRowColumn style={styles.column}>
            <IconButton
                containerElement={<Link to={`${locationAuditPath}/${data.location}/${data.audit_uuid}/show`}/>}
                style={styles.icon}
            >
                <ContentView color={FuseTheme.palette.primary1Color}/>
            </IconButton>
        </TableRowColumn>
        }
    </TableRow>
);

LocationAuditStaticTableRow.propTypes = {
    data: PropTypes.object.isRequired,
    locationAuditPath: PropTypes.string,
    showView: PropTypes.bool,
};

LocationAuditStaticTableRow.defaultProps = {
    locationAuditPath: '/LocationAudits',
    style: {padding: 0},
};

export default LocationAuditStaticTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/LocationAuditStaticTableRow.js